var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChange = function SvgChange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.83314 5.83324h8.33336v1.49167c0 .375.45.55833.7083.29167l2.325-2.325c.1667-.16667.1667-.425 0-.59167l-2.325-2.325c-.2583-.25833-.7083-.075-.7083.3v1.49167h-9.1667c-.45833 0-.83333.375-.83333.83333v3.33333c0 .45834.375.83334.83333.83334.45834 0 .83334-.375.83334-.83334zm8.33336 8.33336h-8.33336v-1.4917c0-.375-.45-.5583-.70834-.2917l-2.325 2.325c-.16666.1667-.16666.425 0 .5917l2.325 2.325c.25834.2583.70834.075.70834-.3v-1.4917h9.16666c.4583 0 .8333-.375.8333-.8333v-3.3333c0-.4584-.375-.8334-.8333-.8334s-.8333.375-.8333.8334z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change.b1be1db0.svg";
export { ForwardRef as ReactComponent };